import { nextTick, onMounted } from 'vue';

interface UseDeferredPageviewOptions {
  // Запускается сразу в onMounted (например, старт загрузки данных).
  beforePageview?: () => void;
  // Отправка события pageview после отрисовки критического контента.
  pageview: () => void;
}

// Откладывает аналитику pageview до того, как основной контент отрендерится:
// beforePageview → nextTick → pageview.
export const useDeferredPageview = ({ beforePageview, pageview }: UseDeferredPageviewOptions) => {
  onMounted(async () => {
    beforePageview?.();
    // Ждём следующий тик, чтобы основной контент успел отрендериться
    await nextTick();

    pageview();
  });
};
